var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.067 1.098h12.334c.693 0 1.342.338 1.734.9 3.144 4.722 4.716 7.587 4.716 8.595v7.996c0 .758-.95 1.444-2.851 2.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.416 20.65l-4.268-.388v-9.113h28.92V1.099m15.25 19.434a4.417 4.417 0 11-8.834.001 4.417 4.417 0 018.834-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.282 20.533a4.417 4.417 0 11-8.834.001 4.417 4.417 0 018.834-.001zm.68 1.117h20.523"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.909d2d0e10f45a4bfa73365e5752b968.svg";
export { ForwardRef as ReactComponent };